module.exports = __webpack_public_path__ + "img/cate.5ed1ea37.svg";